<template>
	<el-table
			:span-method="arraySpanMethod"
			v-if=" !loading && show && updatePoints && tableData.length > 0"
			height="100%"
			:data="tableData"
			style="width: 100%">
		<el-table-column
				fixed
				prop="loopName"
				label="回路名称"
				width="220"
		>
		</el-table-column>

		<el-table-column
				fixed
				prop="node"
				label="参数名称"
				width="200">
		</el-table-column>

		<el-table-column
				v-for="(item,index) in titles"
				:key="index"
				:prop="item"
				:label="item"
				width="108">
		</el-table-column>

	</el-table>
	<div v-else class="row-center tip">
		<img v-if="loading" src="../../../assets/img/loading.png" class="loading">
		<img v-else src="../../../assets/img/not_found_data.png" alt="">
	</div>
</template>

<script>
	import {floatFormat} from "../../../util/MathUtil"
	import {currentDay, monthDays,dateFormat} from "../../../util/DateUtil";
	import {LOOP_DIAGRAM_DATA_BY_DAY, LOOP_DIAGRAM_DATA_BY_MONTH, LOOP_DIAGRAM_DATA_BY_YEAR} from "../../../api/power";
	import exportExcel from "../../../util/excel";
	import Axios from "axios"
	import dict from "../../../util/dict"
	import ExcelJS from 'exceljs'
	import FileSaver from 'file-saver'
	const UNIT = {
		"PF": "",
		"PFa": "",
		"PFb": "",
		"PFc": "",
		"PA": " kW",
		"PAa": " kW",
		"PAb": " kW",
		"PAc": " kW",
		"PR": " kVar",
		"PRa": " kVar",
		"PRb": " kVar",
		"PRc": " kVar",
		"P": " kVA",
		"Pa": " kVA",
		"Pb": " kVA",
		"Pc": " kVA",
		"F": " Hz",
		"Ua": " V",
		"Ub": " V",
		"Uc": " V",
		"Uab": " V",
		"Ubc": " V",
		"Uac": " V",
		"Ia": " A",
		"Ib": " A",
		"Ic": " A",
	}

	export default {
		props: {
			loops: Array,
			nodes: Array,
			range: String,
			date: Date,
            nodeDetails: Array
		},
		name: "Running",
		data() {
			return {
				currentCancelTokenSource: null,
				loading: false,
				show: false,
				allPoints: {},
				titles: [],
				timeDate:""
			}
		},
		mounted() {
			this.reShow()
			this.getPoints(this.loops, this.nodes, Axios.CancelToken.source())
		},
		computed: {
			diagramStatus(){
				return this.$store.state.project.diagramStatus
			},
			updatePoints() {
				return [this.loops, this.date, this.range, this.nodes,this.nodeDetails]
			},
			tableData() {
				let data = []
				this.loops.forEach(l => {
					this.nodes.forEach(n => {
						let points = this.allPoints[n + "_" + l.loopId];
						let obj = {
							loopName: l.loopName,
							node: n,
						}

						this.tableRowInit(obj)
						if (!points) {
							return []
						}
						points.forEach(p => {
							if(n=="PA"||n=="PAa"||n=="PAb"||n=="PAc"||n=="PR"||n=="PRa"||n=="PRb"||n=="PRc"||n=="P"||n=="Pa"||n=="Pb"||n=="Pc"){
								obj[this.keyGenerate(p.time)] = floatFormat(p.val/1000, 2)+`${UNIT[n]}`
							}else{
								obj[this.keyGenerate(p.time)] = floatFormat(p.val, 2)+`${UNIT[n]}`
							}
							
						})
						// obj.node = `${dict(n)}${UNIT[n]}`;
						obj.node = `${dict(n)}`;
						data.push(obj)
					})
				})

				return data
			},
			dateName(){
				switch (this.range) {
					case 'day':
						this.timeDate = dateFormat("YY-mm-dd", this.date)
						return "日"
						break;
					case 'week':
						this.timeDate = dateFormat("YY-mm-dd", this.date)
						return "周"
						break;
					case 'month':
						this.timeDate = dateFormat("YY-mm", this.date)
						return "月"
						break;
					case 'year':
						this.timeDate = dateFormat("YY", this.date)
						return "年"
						break;
					default:
						this.timeDate = dateFormat("YY-mm-dd", this.date)
						return "日"
						break;
				}
			},
			selProjectName() {
				return this.$store.getters.selProjectInfo.projectName;
			},
		},
		methods: {
			keyGenerate(time) {
				let date = new Date(time)
				switch (this.range) {
					case "day":
						let hours = date.getHours();
						return hours + '点'
					case "month":
						return currentDay(date) + '日'
					case "year":
						return date.getMonth() + 1 + '月'
				}
			},
			async getPoints(loops, nodes, source) {

				this.currentCancelTokenSource = source

				this.allPoints = {}
				if (!loops) {
					return
				}
				this.loading = true


				let promises = []

				for (let i = 0; i < loops.length; i++) {
					let l = loops[i]
					let temp = nodes.map(n => {

						switch (this.range) {
							case "day":
								this.titles = []
								for (let i = 0; i < 24; i++) {
									this.$set(this.titles, i, i + '点')
								}
								return LOOP_DIAGRAM_DATA_BY_DAY(l.loopId, n, this.date, source)
							case "month":
								this.titles = []
								for (let i = 0; i < monthDays(this.date); i++) {
									this.$set(this.titles, i, i + 1 + '日')
								}
								return LOOP_DIAGRAM_DATA_BY_MONTH(l.loopId, n, this.date, source)
							case "year":
								this.titles = []
								for (let i = 0; i < 12; i++) {
									this.$set(this.titles, i, i + 1 + '月')
								}
								return LOOP_DIAGRAM_DATA_BY_YEAR(l.loopId, n, this.date, source)
						}

					})
					this.savePoints(temp, nodes, l)
					promises = promises.concat(temp)
				}

				await Promise.all(promises)
				this.loading = false
			},
			async savePoints(promises, nodes, l) {
				let res = await Promise.all(promises)
				nodes.forEach((n, j) => {
					this.$set(this.allPoints, `${n}_${l.loopId}`, res[j].data? res[j].data.data.points : [])
				})
				return res
			},
			arraySpanMethod({row, column, rowIndex, columnIndex}) {
				let i = this.nodes.length
				if (columnIndex === 0 && i > 1) {
					if (rowIndex % i !== 0) {
						return [0, 0]
					} else {
						return [i, 1]
					}
				}
			},
			reShow() {
				this.show = false
				this.$nextTick(() => {
					this.show = true
				})
			},

			tableRowInit(obj) {
				this.titles.forEach(k => {
					obj[k] = '--'
				})
			},

		},
		watch: {
			diagramStatus(n){
				if(this.$route.query.uid === 'Running' ){
					if(n.type === 'excel' && this.tableData.length > 0){

						let data = [
							['回路名称', '参数名称']
						]

						let merges = [

						]

						this.titles.forEach(t => {
							data[0].push(t)
						})
						let len = this.nodes.length
						this.tableData.forEach((d, i) => {
							data.push([i % len === 0 ? d.loopName : null, d.node, ...this.titles.map(t => d[t])])

							if(i % len === 0){
								merges.push({s: {r: 1 + i, c: 0}, e: {r: len + i, c: 0}})
							}
						})
						// exportExcel(data, '电力运行报表', merges)
						const workbook = new ExcelJS.Workbook();
						// 创建带有红色标签颜色的工作表
						const sheet = workbook.addWorksheet('Sheet1');

						let letter = ['A','B','C','D','E','F','G','H','I','J','K','L','M','N','O','P','Q','R','S','T','U','V','W','X','Y','Z','AA','AB','AC','AD','AE','AF','AG','AH','AI']
						if(this.range == 'day'){
							letter = letter.filter((e,i)=>i<26)
						}else if(this.range == 'month'){
							letter = letter.filter((e,i)=>i<monthDays(this.date)+2)
						}else{
							letter = letter.filter((e,i)=>i<14)
						}

						let sheetName = ["电力运行"+this.dateName+"报表",this.selProjectName,'日期：'+this.timeDate]
							let style =  {
								fill: {
									type: 'gradient',
									gradient: 'angle',
									degree: 0,
									stops: [
									{ position: 0, color: { argb: 'd9d9d9' } },//单元格渐变色（左） 
									{ position: 0.5, color: { argb: 'd9d9d9' } },//单元格渐变色（中）
									{ position: 1, color: { argb: 'd9d9d9' } }//单元格渐变色（右）
									]
								},
								font20:{
									name: 'Arial',
									size: 20,
									bold: true
								},
								font12bold:{
									name: 'Arial',
									size: 12,
									bold: true
								},
								font12:{
									name: 'Arial',
									size: 12,
									// bold: true
								},
								alignmentCenter:{ vertical: 'middle', horizontal: 'center' },
								alignmentLeft:{ vertical: 'middle', horizontal: 'left' },
								border:{
									top: {style:'thin'},
									left: {style:'thin'},
									bottom: {style:'thin'},
									right: {style:'thin'}
								}
							}

							//处理一二层
				
							sheet.mergeCells(letter[0]+'1:'+letter[letter.length-1]+'1');
							sheet.getCell(letter[0]+'1').value = sheetName[0]
							sheet.getCell(letter[0]+'1').font = style.font20
							sheet.getCell(letter[0]+'1').alignment = style.alignmentCenter
							
							sheet.mergeCells('A2:B2');
							sheet.mergeCells('C2:'+letter[letter.length-1]+'2');
							sheet.getCell('A2').value = sheetName[1]
							sheet.getCell('C2').value = sheetName[2]
							sheet.getRow(2).font=style.font12bold
							sheet.getRow(2).alignment = style.alignmentLeft
							const rows = sheet.getRows(1, 2);
							rows.map(e=>{e.height = 50 ;return e})

							//表格设置
							let columns = []
							data[0].forEach(item=>{
								columns.push({
									name:item,
								})
							})
							sheet.addTable({
								name: 'MyTable',
								ref: 'A3', // 表格左上角的位置
								headerRow: true,
								totalsRow: false,
								style: {
									theme: 'TableStyleLight1',
									font:{
										name: 'Arial',
										size: 12,
										// bold: true
									},
								},
									//            showRowStripes: true,
								columns:columns,
								rows: data.slice(1),
							})
							this.tableData.forEach((d, i) => {
								if(i % len === 0){
									sheet.mergeCells('A'+(4 + i)+':A'+(len + i+3));
								}
							})

							//表格头部样式
							sheet.getRow(3).height = 59
							sheet.getRow(3).font=style.font12bold
							
							letter.forEach(item=>{
								sheet.getCell(item+'3').fill = style.fill
								sheet.getCell(item+'3').border = style.border
								sheet.getRow(3).alignment = style.alignmentCenter
							})
							data.slice(1).forEach((item,index)=>{
								sheet.getRow(4+index).height = 38
								sheet.getRow(4+index).font=style.font12
								letter.forEach((e,i)=>{
									if(i<=1){
										sheet.getColumn(e).width = 26
									}else{
										sheet.getColumn(e).width = 14
									}
									sheet.getCell(e+(4+index)).border = style.border
								})
							
								sheet.getRow(4+index).alignment = style.alignmentCenter
							})
						

						// workbook.xlsx.writeFile('test.xlsx')
						workbook.xlsx.writeBuffer().then(buffer => {
							FileSaver.saveAs(new Blob([buffer], { type: 'application/octet-stream' }), `${sheetName[0]}.xlsx`);
						})

					}else {
						this.$message.warning("无图表数据！")
					}
				}
			},
			updatePoints(n) {
				this.currentCancelTokenSource.cancel("请求取消")
				this.reShow()
				this.getPoints(this.loops, this.nodes, Axios.CancelToken.source())
			}
		}
	}
</script>

<style scoped lang="less">
	.tip {
		width: 100%;
		height: 100%;
		font-size: 16rem;
		color: #8c939d;
	}

	.loading {
		width: 28rem;
		height: 28rem;
		animation: loading 1s linear infinite;
	}

	@keyframes loading {
		0% {
			transform: rotate(0);
		}
		100% {
			transform: rotate(360deg);
		}
	}
</style>